'use client';

import { useEffect, useState } from 'react';
import { useTranslations } from '@/i18n/intl';
import { SectionLabel } from '@/components/shared/SectionLabel';
import { ServiceCard } from '@/components/shared/ServiceCard';
import { getServices } from '@/lib/actions/services';
import { getSettings } from '@/lib/actions/settings';
import { RichText } from '@/components/shared/RichText';

export function ServicesSection() {
  const t = useTranslations('Expertise');
  const tCommon = useTranslations('Common');
  const [services, setServices] = useState<any[]>([]);
  const [serviceIntro, setServiceIntro] = useState<string | undefined>();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const allServices = await getServices();
      const settings = await getSettings(['home_service_intro']);
      if (cancelled) return;
      setServices(allServices.slice(0, 4));
      setServiceIntro(settings.home_service_intro);
      setReady(true);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready || services.length === 0) return null;

  return (
    <section className="py-20 md:py-32 px-5 md:px-[40px] bg-[#FAFAFA]">
      <div className="max-w-[1170px] mx-auto">
        <div className="text-left mb-16">
          <SectionLabel text={tCommon('expertise')} />
          <h2
            className="text-2xl md:text-3xl lg:text-[40px] font-semibold text-navy leading-[1.2] mb-6 font-heading tracking-tight"
          >
            {t('intro')}
          </h2>
          {serviceIntro ? (
            <RichText
              html={serviceIntro}
              className="text-lg text-gray-500 font-sans leading-relaxed font-light [&_p]:mb-4"
            />
          ) : (
            <p className="text-lg text-gray-500 font-sans leading-relaxed font-light">
              {t('introSubtitle')}
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {services.map((service: any) => (
            <ServiceCard
              key={service.slug}
              title={service.title}
              description={service.shortDescription}
              href={`/services/${service.slug}`}
              image={service.homeImage || service.image}
              category={service.category?.name}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
